import { Component, computed, input } from '@angular/core';
import { ClassValue } from 'clsx';
import { bui } from '../utils';

@Component({
  selector: 'alert-dialog-title',
  host: {
    '[class]': 'computedClass()',
  },
  template: `<ng-content />`,
})
export class AlertDialogTitle {
  // Inputs / Outputs
  readonly userClass = input<ClassValue>('', { alias: 'class' });

  // State
  protected readonly computedClass = computed(() =>
    bui(
      // Base
      'text-lg font-medium',

      // User classes
      this.userClass(),
    ),
  );
}
